import {
    LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN,
    LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE,
    LOAD_STOW_CART_DATA_FOR_CART_LOCATION,
    LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION,
    LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION
} from "../actions/CartLocationActions";

/**
 * Initial state of the system.
 */
const initialState = {
    loading: true,
    inductPackageMetricsMap: {},
    stowCartData: {},
    stowCartLocationsData: {},
    stowPackageMetricsMap: {}
}

/**
 * Reducer function for Floor View that changes state
 * based on the action triggered.
 */
export default function cartLocationReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_STOW_CART_DATA_FOR_CART_LOCATION:
            return {
                ...state,
                loading: false,
                stowCartData: {
                    ...state.stowCartData,
                    [action.stowCartData.floor]: action.stowCartData.cartData
                }
            };
        case LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION:
            return {
                ...state,
                loading: false,
                stowCartLocationsData: action.stowFloorsData
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/CartLocationReducer.js